import axios from "axios";
import { NotImplementedError } from "../../errors";
import { PromiseHandler } from "../../handlers";
import { FilterTypes } from "../../handlers/filter";
import { googlePlaceFromService } from "../../models/aiCreative";
import Assets from "./assets";
import { AiCreativePlacesFetchFailed } from "./errors";
import GenerateJobs from "./generateJobs";
import Jobs from "./jobs";
// SearchPlaces (services/creative/internal/service/places_search.go) rejects
// any query under 2 characters with a 400. The hook enforces this already,
// but a direct SDK caller (or find({})) wouldn't be.
export const MIN_QUERY_LENGTH = 2;
/**
 * Handles services/creative's places-search endpoint directly; generate-jobs,
 * status-polling, job-listing, and asset-download live in their own
 * single-endpoint sub-modules below. Named `aiCreative` rather than
 * `creatives` to avoid colliding with the existing, unrelated
 * `modules/creatives` (encoder-based campaign assets).
 *
 * `find`/`searchPlaces` is the only find/save/delete-shaped operation here —
 * save, delete, and make are intentionally unsupported. Brand analysis,
 * generate-jobs, job-listing, and asset downloads don't fit that shape at all
 * (each hits its own distinct endpoint with its own payload shape), so they
 * live in the {@link GenerateJobs}, {@link Jobs}, and {@link Assets}
 * sub-modules. Brand analysis itself goes through Seller's
 * `useBrandAnalysis`/`MadSDK.brandKits.analyze` rather than a sub-module
 * here.
 */
export default class AiCreative extends PromiseHandler {
    constructor(sdk) {
        super(sdk, "aiCreative");
        this.assets = new Assets(sdk);
        this.generateJobs = new GenerateJobs(sdk);
        this.jobs = new Jobs(sdk);
    }
    getIdentifierKey() {
        return "placeId";
    }
    async findItems(filters) {
        const query = String(filters.where?.find((clause) => clause.field === "query")?.value ?? "");
        if (query.trim().length < MIN_QUERY_LENGTH)
            return [];
        try {
            const res = await axios.get(`${this.sdk.urls.creativeBaseUrl}/api/v1/creative/places/search`, { params: { query } });
            return res.data.map(googlePlaceFromService);
        }
        catch (err) {
            throw new AiCreativePlacesFetchFailed(err);
        }
    }
    saveItem(_place) {
        throw new NotImplementedError("AiCreative places cannot be saved");
    }
    deleteItem(_id) {
        throw new NotImplementedError("AiCreative places cannot be deleted");
    }
    searchPlaces(query) {
        return this.find({
            where: [{ field: "query", type: FilterTypes.EQ, value: query }]
        });
    }
}
//# sourceMappingURL=index.js.map